import uniqBy from "lodash/uniqBy";
import { handleActions } from "redux-actions";

import { updateById } from "utils";

const assetDealReducer = handleActions(
  {
    ASSET_DEALS_GET: {
      FULFILLED: ({ assetDeals }, { payload }) => ({
        assetDeals: uniqBy([...assetDeals, ...payload.assetDeals], "id"),
      }),
    },

    ASSET_DEAL_UPDATE: {
      FULFILLED: ({ assetDeals }, { payload: { assetDeal } }) => ({
        assetDeals: updateById(assetDeals, assetDeal),
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default assetDealReducer;
